import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { NavLink, Accordion } from '@any-ui-react/core';

import { RouteCategory, useScreenBreakpoint } from '@anyx/shared-utils';

import { MenuLink } from './MenuLink';
import { navItemStyles } from './styles';

export const AccordionLink = ({
  activePath,
  isActive,
  category,
  onLinkClick,
  setActiveMenu,
}: {
  activePath: string;
  isActive: boolean;
  category: RouteCategory;
  onLinkClick: () => void;
  setActiveMenu: (value?: string) => void;
}) => {
  const { t } = useTranslation();
  const isLargeScreen = useScreenBreakpoint('lg');
  const classes = navItemStyles({ active: isActive });
  const navigate = useNavigate();

  return (
    <Accordion.Item value={category.name.key}>
      <Accordion.Control>
        {isLargeScreen ? (
          <NavLink
            active={category.activePath === activePath}
            classNames={{
              root: classes.root({
                active: category.activePath === activePath,
              }),
              section: classes.icon({
                active: category.activePath === activePath || isActive,
              }),
              label: classes.title({
                active: category.activePath === activePath,
              }),
            }}
            label={t(category.name.key, category.name.options || {})}
            leftSection={category.icon?.({ className: classes.icon() })}
            onClick={() => {
              onLinkClick();
              navigate(category.path ?? '');
            }}
            rightSection={category.aside}
          />
        ) : (
          <NavLink
            onClick={() => setActiveMenu(category.name.key)}
            active={category.activePath === activePath || isActive}
            classNames={{
              root: classes.root({
                active: category.activePath === activePath,
              }),
              section: classes.icon({
                active: category.activePath === activePath || isActive,
              }),
              label: classes.title({
                active: category.activePath === activePath,
              }),
            }}
            leftSection={category.icon?.({
              className: classes.icon(),
            })}
            label={t(category.name.key, category.name.options || {})}
            rightSection={category.aside}
          />
        )}
      </Accordion.Control>
      <div className="flex flex-col">
        {!isLargeScreen && (
          <Accordion.Panel key={category.name.key}>
            <NavLink
              active={category.activePath === activePath}
              classNames={{
                root: classes.root({ active: false, light: true }),
                label: classes.title({ class: 'ml-8' }),
              }}
              label={t(category.name.key, category.name.options || {})}
              onClick={() => {
                onLinkClick();
                navigate(category.path ?? '');
              }}
              rightSection={category.aside}
            />
          </Accordion.Panel>
        )}
        {category.children?.map((link, i) => {
          const isLinkActive = link.activePath === activePath;

          if (link.type === 'menu') {
            return (
              <Accordion.Panel key={`${link.name.key}-${i}`}>
                <MenuLink
                  name={t(link.name.key, link.name.options || {})}
                  aside={link.aside}
                  links={link.children}
                  activePath={activePath}
                  menuActive={isLinkActive}
                  path={link.path}
                  onClick={onLinkClick}
                />
              </Accordion.Panel>
            );
          }

          return (
            <Accordion.Panel key={`${link.name.key}-${i}`}>
              <NavLink
                classNames={{
                  root: classes.root({ active: isLinkActive, light: true }),
                  label: classes.title({ class: 'ml-8' }),
                }}
                active={isLinkActive}
                onClick={() => {
                  onLinkClick();
                  navigate(link.path ?? '');
                }}
                label={t(link.name.key, link.name.options || {})}
                rightSection={link.aside}
              />
            </Accordion.Panel>
          );
        })}
      </div>
    </Accordion.Item>
  );
};
